import styled, { keyframes } from 'styled-components';
import { defaultTheme } from 'constants/theme/defaultTheme';

// copied from here: https://dev.to/kirteshbansal/bouncing-dots-loader-in-react-4jng

const Animation = keyframes`
  to {
    opacity: 0.1;
    transform: translateY(-12px);
  }
}
`;

export const InlineLoaderWrapper = styled.div`
  display: flex;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Dot = styled.div`
  width: 9px;
  height: 9px;
  margin: 14px 5px;
  border-radius: 50%;
  background-color: ${defaultTheme.colors.blue};
  opacity: 1;
  animation: ${Animation} 0.6s infinite alternate;

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }
`;
